/*
 * Fysiokaupan laskurit - natiivi toteutus.
 *
 * Korvaa aiemmat iframe-upotukset (laskurit-fysiokauppa.netlify.app).
 * Kaytto artikkelin sisallossa:  <div data-laskuri="bmi"></div>
 *
 * Jokainen laskuri on maarittely: { title, fields, compute }.
 * compute(v) saa kenttien arvot ja palauttaa tulosobjektin:
 *   { value, unit, label, tone: 'good'|'warn'|'bad', rows: [[avain, arvo]],
 *     table: {head, rows, activeIndex}, chips: [{text, best}], note }
 */
(function () {
  'use strict';

  // ---------------------------------------------------------------- apurit

  function round(n, d) {
    var f = Math.pow(10, d || 0);
    return Math.round(n * f) / f;
  }

  function fi(n, d) {
    if (!isFinite(n)) return '-';
    return round(n, d).toLocaleString('fi-FI', {
      minimumFractionDigits: d || 0,
      maximumFractionDigits: d || 0
    });
  }

  function mmss(totalSeconds) {
    var m = Math.floor(totalSeconds / 60);
    var s = Math.round(totalSeconds % 60);
    if (s === 60) { m += 1; s = 0; }
    return m + ':' + String(s).padStart(2, '0');
  }

  function clamp(n, min, max) {
    return Math.min(Math.max(n, min), max);
  }

  // Mifflin-St Jeor. Kaytetaan kaikissa perusaineenvaihdunnan laskureissa,
  // jotta sama henkilo saa saman tuloksen laskurista riippumatta.
  function bmr(sex, weight, height, age) {
    var base = 10 * weight + 6.25 * height - 5 * age;
    return sex === 'nainen' ? base - 161 : base + 5;
  }

  var ACTIVITY = [
    { value: '1.2', label: 'Vähäinen liikunta (toimistotyö)' },
    { value: '1.375', label: 'Kevyt liikunta (1–3 krt/vko)' },
    { value: '1.55', label: 'Kohtalainen liikunta (3–5 krt/vko)' },
    { value: '1.725', label: 'Aktiivinen liikunta (6–7 krt/vko)' },
    { value: '1.9', label: 'Erittäin aktiivinen (urheilija)' }
  ];

  var SEX = [
    { value: 'mies', label: 'Mies' },
    { value: 'nainen', label: 'Nainen' }
  ];

  var LASKURIT = {};

  // ---------------------------------------------------------------- BMI

  LASKURIT.bmi = {
    title: 'BMI-laskuri',
    fields: [
      { id: 'paino', label: 'Paino (kg)', type: 'range', min: 30, max: 200, step: 0.5, value: 70 },
      { id: 'pituus', label: 'Pituus (cm)', type: 'range', min: 140, max: 220, step: 1, value: 170 }
    ],
    compute: function (v) {
      var m = v.pituus / 100;
      var bmi = v.paino / (m * m);
      // Rajat WHO:n luokituksen mukaan. Aiempi toteutus luokitteli
      // valin 18,5-18,9 alipainoksi, mika oli ristiriidassa sivun oman
      // taulukon kanssa.
      var label, tone;
      if (bmi < 16) { label = 'Sairaalloinen alipaino'; tone = 'bad'; }
      else if (bmi < 17) { label = 'Merkittävä alipaino'; tone = 'bad'; }
      else if (bmi < 18.5) { label = 'Lievä alipaino'; tone = 'warn'; }
      else if (bmi < 25) { label = 'Normaali paino'; tone = 'good'; }
      else if (bmi < 30) { label = 'Lievä ylipaino'; tone = 'warn'; }
      else if (bmi < 35) { label = 'Merkittävä ylipaino'; tone = 'bad'; }
      else if (bmi < 40) { label = 'Vaikea ylipaino'; tone = 'bad'; }
      else { label = 'Sairaalloinen ylipaino'; tone = 'bad'; }

      var minW = 18.5 * m * m;
      var maxW = 24.9 * m * m;

      return {
        value: fi(bmi, 1),
        label: label,
        tone: tone,
        rows: [
          ['Normaalipainon vaihteluväli', fi(minW, 1) + '–' + fi(maxW, 1) + ' kg'],
          ['Ero normaalipainon ylärajaan', v.paino > maxW ? '+' + fi(v.paino - maxW, 1) + ' kg' : '–'],
          ['Kaava', 'paino ÷ pituus²']
        ],
        note: 'BMI ei erottele lihasta ja rasvaa, eikä se sovellu sellaisenaan lapsille, raskaana oleville tai voimaurheilijoille.'
      };
    }
  };

  // ---------------------------------------------------------------- laihdutus

  LASKURIT.laihdutus = {
    title: 'Laihdutuslaskuri',
    fields: [
      { id: 'paino', label: 'Nykyinen paino (kg)', type: 'range', min: 40, max: 200, step: 0.5, value: 80 },
      { id: 'tavoite', label: 'Tavoitepaino (kg)', type: 'range', min: 40, max: 200, step: 0.5, value: 70 },
      { id: 'pituus', label: 'Pituus (cm)', type: 'range', min: 140, max: 220, step: 1, value: 170 },
      { id: 'ika', label: 'Ikä (vuotta)', type: 'range', min: 18, max: 100, step: 1, value: 30 },
      { id: 'sukupuoli', label: 'Sukupuoli', type: 'select', options: SEX },
      { id: 'aktiivisuus', label: 'Aktiivisuustaso', type: 'select', options: ACTIVITY, value: '1.375' }
    ],
    compute: function (v) {
      var b = bmr(v.sukupuoli, v.paino, v.pituus, v.ika);
      var tdee = b * parseFloat(v.aktiivisuus);
      var muutos = v.paino - v.tavoite;

      // Turvaraja: paivittainen saanti ei saa pudota alle yleisesti kaytetyn
      // alarajan (naiset 1200 kcal, miehet 1500 kcal), joten vaje skaalataan.
      var minKcal = v.sukupuoli === 'nainen' ? 1200 : 1500;

      if (muutos <= 0) {
        // Tavoite on nykyista suurempi tai sama -> ei laihdutusta.
        var lisays = Math.abs(muutos);
        return {
          value: fi(tdee, 0),
          unit: 'kcal/vrk',
          label: muutos === 0 ? 'Painon ylläpito' : 'Tavoite on nykyistä painoa suurempi',
          tone: 'good',
          rows: [
            ['Perusaineenvaihdunta (BMR)', fi(b, 0) + ' kcal/vrk'],
            ['Kulutus arjessa (TDEE)', fi(tdee, 0) + ' kcal/vrk'],
            ['Painonnousuun tarvittava lisä', lisays > 0 ? '+300…500 kcal/vrk' : '–'],
            ['Arvioitu aika tavoitteeseen', lisays > 0 ? fi(lisays / 0.35, 0) + ' viikkoa' : '–']
          ],
          note: 'Painon nousu turvallista vauhtia on noin 0,25–0,5 kg viikossa.'
        };
      }

      var toivottuVaje = 500;
      var vaje = Math.min(toivottuVaje, Math.max(0, tdee - minKcal));
      var saanti = tdee - vaje;
      var viikot = vaje > 0 ? (muutos * 7700) / (vaje * 7) : Infinity;
      var vauhti = (vaje * 7) / 7700;

      var rows = [
        ['Perusaineenvaihdunta (BMR)', fi(b, 0) + ' kcal/vrk'],
        ['Kulutus arjessa (TDEE)', fi(tdee, 0) + ' kcal/vrk'],
        ['Suositeltu päivittäinen saanti', fi(saanti, 0) + ' kcal/vrk'],
        ['Päivittäinen kalorivaje', fi(vaje, 0) + ' kcal'],
        ['Pudotusvauhti', fi(vauhti, 2) + ' kg/vko'],
        ['Pudotettavaa', fi(muutos, 1) + ' kg']
      ];

      var note = '1 kg rasvakudosta vastaa noin 7 700 kcal. Arvio on suuntaa-antava.';
      if (vaje < toivottuVaje) {
        note = 'Kalorivajetta on pienennetty, jotta päivittäinen saanti ei laske alle ' +
          minKcal + ' kcal:n. ' + note;
      }

      return {
        value: isFinite(viikot) ? fi(viikot, 0) : '–',
        unit: 'viikkoa',
        label: 'Arvioitu aika tavoitepainoon',
        tone: 'good',
        rows: rows,
        note: note
      };
    }
  };

  // ---------------------------------------------------------------- juoksunopeus

  LASKURIT.juoksunopeus = {
    title: 'Juoksunopeuslaskuri',
    fields: [
      { id: 'matka', label: 'Matka (km)', type: 'range', min: 1, max: 42.2, step: 0.1, value: 5 },
      { id: 'tunnit', label: 'Tunnit', type: 'number', min: 0, max: 24, step: 1, value: 0 },
      { id: 'minuutit', label: 'Minuutit', type: 'number', min: 0, max: 59, step: 1, value: 25 },
      { id: 'sekunnit', label: 'Sekunnit', type: 'number', min: 0, max: 59, step: 1, value: 0 }
    ],
    compute: function (v) {
      var sek = v.tunnit * 3600 + v.minuutit * 60 + v.sekunnit;
      if (!(v.matka > 0) || !(sek > 0)) {
        return { value: '–', label: 'Syötä matka ja aika', tone: 'warn', rows: [] };
      }
      var tahti = sek / v.matka;
      var nopeus = (v.matka / sek) * 3600;

      var label, tone;
      if (tahti > 600) { label = 'Kävely'; tone = 'warn'; }
      else if (tahti > 480) { label = 'Hölkkä'; tone = 'good'; }
      else if (tahti > 300) { label = 'Juoksu'; tone = 'good'; }
      else if (tahti > 240) { label = 'Vauhdikas juoksu'; tone = 'good'; }
      else { label = 'Kilpavauhti'; tone = 'good'; }

      // Yleisimmat matkat samalla tahdilla
      var matkat = [
        ['5 km', 5], ['10 km', 10], ['Puolimaraton', 21.0975], ['Maraton', 42.195]
      ];
      var rows = matkat.map(function (m) {
        var t = tahti * m[1];
        var h = Math.floor(t / 3600);
        var jaa = t - h * 3600;
        return [m[0] + ' samalla tahdilla', (h > 0 ? h + ':' + mmss(jaa).padStart(5, '0') : mmss(jaa))];
      });

      return {
        value: mmss(tahti),
        unit: 'min/km',
        label: label,
        tone: tone,
        rows: [['Keskinopeus', fi(nopeus, 1) + ' km/h']].concat(rows)
      };
    }
  };

  // ---------------------------------------------------------------- rasvaprosentti

  LASKURIT.rasvaprosentti = {
    title: 'Rasvaprosenttilaskuri',
    fields: [
      { id: 'sukupuoli', label: 'Sukupuoli', type: 'select', options: SEX },
      { id: 'vyotaro', label: 'Vyötärönympärys (cm)', type: 'range', min: 50, max: 150, step: 0.5, value: 80 },
      { id: 'kaula', label: 'Kaulanympärys (cm)', type: 'range', min: 20, max: 60, step: 0.5, value: 35 },
      { id: 'lantio', label: 'Lantionympärys (cm)', type: 'range', min: 60, max: 160, step: 0.5, value: 95, showIf: { sukupuoli: 'nainen' } },
      { id: 'pituus', label: 'Pituus (cm)', type: 'range', min: 140, max: 220, step: 1, value: 170 }
    ],
    compute: function (v) {
      // U.S. Navy -kaava
      var p;
      if (v.sukupuoli === 'nainen') {
        var sisus = v.vyotaro + v.lantio - v.kaula;
        if (sisus <= 0) return { value: '–', label: 'Tarkista mitat', tone: 'warn', rows: [] };
        p = 495 / (1.29579 - 0.35004 * Math.log10(sisus) + 0.22100 * Math.log10(v.pituus)) - 450;
      } else {
        var ero = v.vyotaro - v.kaula;
        if (ero <= 0) return { value: '–', label: 'Vyötärön tulee olla kaulaa suurempi', tone: 'warn', rows: [] };
        p = 495 / (1.0324 - 0.19077 * Math.log10(ero) + 0.15456 * Math.log10(v.pituus)) - 450;
      }
      p = clamp(p, 2, 60);

      var rajat = v.sukupuoli === 'nainen'
        ? [[13, 'Välttämätön rasva', 'warn'], [21, 'Urheilija', 'good'], [25, 'Fitness', 'good'], [32, 'Normaali', 'good']]
        : [[6, 'Välttämätön rasva', 'warn'], [14, 'Urheilija', 'good'], [18, 'Fitness', 'good'], [25, 'Normaali', 'good']];
      var label = 'Korkea', tone = 'warn';
      for (var i = 0; i < rajat.length; i++) {
        if (p < rajat[i][0]) { label = rajat[i][1]; tone = rajat[i][2]; break; }
      }

      return {
        value: fi(p, 1),
        unit: '%',
        label: label,
        tone: tone,
        rows: [
          ['Menetelmä', 'U.S. Navy -kaava'],
          ['Rasvamassa arviolta', '–'],
          ['Mittaustapa', 'Mittaa rentona, uloshengityksen jälkeen']
        ],
        note: 'Ympärysmittoihin perustuva arvio. Tarkempaan tulokseen tarvitaan esim. bioimpedanssi- tai DEXA-mittaus.'
      };
    }
  };

  // ---------------------------------------------------------------- maksimisyke

  LASKURIT.maksimisyke = {
    title: 'Maksimisykelaskuri',
    fields: [
      { id: 'ika', label: 'Ikä (vuotta)', type: 'range', min: 15, max: 100, step: 1, value: 30 },
      { id: 'leposyke', label: 'Leposyke (bpm)', type: 'range', min: 35, max: 100, step: 1, value: 60 },
      {
        id: 'kaava', label: 'Laskentakaava', type: 'select', options: [
          { value: 'tanaka', label: 'Tanaka (2001): 208 − 0,7 × ikä' },
          { value: 'perinteinen', label: 'Perinteinen: 220 − ikä' },
          { value: 'gellish', label: 'Gellish (2007): 207 − 0,7 × ikä' }
        ]
      },
      {
        id: 'alueet', label: 'Sykealueiden laskutapa', type: 'select', options: [
          { value: 'karvonen', label: 'Karvonen (sykereservi, huomioi leposykkeen)' },
          { value: 'prosentti', label: 'Prosenttia maksimisykkeestä' }
        ]
      }
    ],
    compute: function (v) {
      var max;
      if (v.kaava === 'perinteinen') max = 220 - v.ika;
      else if (v.kaava === 'gellish') max = 207 - 0.7 * v.ika;
      else max = 208 - 0.7 * v.ika;
      max = Math.round(max);

      var reservi = max - v.leposyke;
      var vyohykkeet = [
        ['Z1 Palauttava', 0.5, 0.6],
        ['Z2 Peruskestävyys', 0.6, 0.7],
        ['Z3 Vauhtikestävyys', 0.7, 0.8],
        ['Z4 Maksimikestävyys', 0.8, 0.9],
        ['Z5 Maksimaalinen', 0.9, 1.0]
      ];
      var rows = vyohykkeet.map(function (z) {
        var lo, hi;
        if (v.alueet === 'karvonen') {
          lo = v.leposyke + reservi * z[1];
          hi = v.leposyke + reservi * z[2];
        } else {
          lo = max * z[1];
          hi = max * z[2];
        }
        return [z[0] + ' (' + Math.round(z[1] * 100) + '–' + Math.round(z[2] * 100) + ' %)',
          Math.round(lo) + '–' + Math.round(hi) + ' bpm'];
      });

      return {
        value: String(max),
        unit: 'bpm',
        label: 'Arvioitu maksimisyke',
        tone: 'good',
        rows: [['Leposyke', v.leposyke + ' bpm'], ['Sykereservi', reservi + ' bpm']].concat(rows),
        note: 'Kaavat ovat väestötason arvioita; yksilöllinen maksimisyke voi poiketa ±10–12 lyöntiä. Tarkka arvo saadaan rasituskokeella.'
      };
    }
  };

  // ---------------------------------------------------------------- kaloritarve

  LASKURIT.kaloritarve = {
    title: 'Kaloritarvelaskuri',
    fields: [
      { id: 'sukupuoli', label: 'Sukupuoli', type: 'select', options: SEX },
      { id: 'ika', label: 'Ikä (vuotta)', type: 'range', min: 15, max: 100, step: 1, value: 30 },
      { id: 'paino', label: 'Paino (kg)', type: 'range', min: 40, max: 200, step: 0.5, value: 70 },
      { id: 'pituus', label: 'Pituus (cm)', type: 'range', min: 140, max: 220, step: 1, value: 170 },
      { id: 'aktiivisuus', label: 'Aktiivisuustaso', type: 'select', options: ACTIVITY, value: '1.375' },
      {
        id: 'tavoite', label: 'Tavoite', type: 'select', options: [
          { value: '-500', label: 'Painonpudotus' },
          { value: '0', label: 'Painon ylläpito' },
          { value: '500', label: 'Lihasmassan kasvatus' }
        ], value: '0'
      }
    ],
    compute: function (v) {
      var b = bmr(v.sukupuoli, v.paino, v.pituus, v.ika);
      var yllapito = b * parseFloat(v.aktiivisuus);
      var minKcal = v.sukupuoli === 'nainen' ? 1200 : 1500;
      var tavoite = Math.max(minKcal, yllapito + parseFloat(v.tavoite));

      // Makrojakauma: proteiini 1,6 g/kg, rasva 25 % energiasta, loput hiilihydraattia
      var proteiini = v.paino * 1.6;
      var rasva = (tavoite * 0.25) / 9;
      var hiilarit = Math.max(0, (tavoite - proteiini * 4 - rasva * 9) / 4);

      return {
        value: fi(tavoite, 0),
        unit: 'kcal/vrk',
        label: 'Päivittäinen energiantarve',
        tone: 'good',
        rows: [
          ['Perusaineenvaihdunta (BMR)', fi(b, 0) + ' kcal/vrk'],
          ['Ylläpitotaso (TDEE)', fi(yllapito, 0) + ' kcal/vrk'],
          ['Proteiini', fi(proteiini, 0) + ' g'],
          ['Rasva', fi(rasva, 0) + ' g'],
          ['Hiilihydraatit', fi(hiilarit, 0) + ' g']
        ],
        note: 'Laskenta perustuu Mifflin–St Jeor -kaavaan. Makrojakauma on yleissuositus (proteiini 1,6 g/kg, rasva 25 % energiasta).'
      };
    }
  };

  // ---------------------------------------------------------------- kalorinkulutus

  var AKTIVITEETIT = {
    kavely: {
      label: 'Kävely', tasot: [
        { value: '2.5', label: 'Hidas (3 km/h)' },
        { value: '3.5', label: 'Normaali (5 km/h)' },
        { value: '4.3', label: 'Reipas (6,5 km/h)' }
      ]
    },
    juoksu: {
      label: 'Juoksu', tasot: [
        { value: '7', label: 'Hölkkä (8 km/h)' },
        { value: '9', label: 'Juoksu (10 km/h)' },
        { value: '11', label: 'Vauhdikas (12 km/h)' },
        { value: '14', label: 'Sprintti (14+ km/h)' }
      ]
    },
    pyoraily: {
      label: 'Pyöräily', tasot: [
        { value: '4', label: 'Kevyt (15 km/h)' },
        { value: '6', label: 'Reipas (20 km/h)' },
        { value: '8', label: 'Vauhdikas (25+ km/h)' }
      ]
    },
    uinti: {
      label: 'Uinti', tasot: [
        { value: '5', label: 'Rauhallinen' },
        { value: '7', label: 'Reipas' },
        { value: '9', label: 'Vauhdikas' }
      ]
    },
    kuntosali: {
      label: 'Kuntosali', tasot: [
        { value: '3.5', label: 'Kevyt harjoittelu' },
        { value: '5', label: 'Keskiraskas harjoittelu' },
        { value: '6', label: 'Raskas harjoittelu' }
      ]
    }
  };

  LASKURIT.kalorinkulutus = {
    title: 'Kalorinkulutuslaskuri',
    fields: [
      { id: 'paino', label: 'Paino (kg)', type: 'range', min: 40, max: 200, step: 0.5, value: 70 },
      {
        id: 'laji', label: 'Aktiviteetti', type: 'select',
        options: Object.keys(AKTIVITEETIT).map(function (k) {
          return { value: k, label: AKTIVITEETIT[k].label };
        })
      },
      { id: 'met', label: 'Intensiteetti', type: 'select', options: [], dependsOn: 'laji' },
      { id: 'kesto', label: 'Kesto (minuuttia)', type: 'range', min: 5, max: 180, step: 5, value: 30 }
    ],
    optionsFor: function (fieldId, v) {
      if (fieldId === 'met') return (AKTIVITEETIT[v.laji] || AKTIVITEETIT.kavely).tasot;
      return null;
    },
    compute: function (v) {
      var met = parseFloat(v.met);
      // Kulutus (kcal) = MET x 3,5 x paino(kg) / 200 x kesto(min)
      var kcal = (met * 3.5 * v.paino / 200) * v.kesto;
      var rasvaG = kcal / 7.7 * 1; // 1 g rasvaa ~ 7,7 kcal
      return {
        value: fi(kcal, 0),
        unit: 'kcal',
        label: (AKTIVITEETIT[v.laji] || {}).label + ', ' + v.kesto + ' min',
        tone: 'good',
        rows: [
          ['MET-arvo', fi(met, 1)],
          ['Kulutus tunnissa', fi(met * 3.5 * v.paino / 200 * 60, 0) + ' kcal'],
          ['Vastaa rasvana', fi(rasvaG, 0) + ' g'],
          ['Kaava', 'MET × 3,5 × paino ÷ 200 × minuutit']
        ],
        note: 'MET-arvot ovat Compendium of Physical Activities -tyyppisiä keskiarvoja. Todellinen kulutus vaihtelee kunnon ja tekniikan mukaan.'
      };
    }
  };

  // ---------------------------------------------------------------- painonnosto (1RM)

  LASKURIT.painonnosto = {
    title: 'Maksimivoimalaskuri (1RM)',
    fields: [
      {
        id: 'liike', label: 'Liike', type: 'select', options: [
          { value: 'Penkkipunnerrus', label: 'Penkkipunnerrus' },
          { value: 'Kyykky', label: 'Kyykky' },
          { value: 'Maastaveto', label: 'Maastaveto' },
          { value: 'Pystypunnerrus', label: 'Pystypunnerrus' },
          { value: 'Kulmasoutu', label: 'Kulmasoutu' }
        ]
      },
      { id: 'paino', label: 'Käytetty paino (kg)', type: 'range', min: 5, max: 300, step: 2.5, value: 60 },
      { id: 'toistot', label: 'Toistot', type: 'range', min: 1, max: 20, step: 1, value: 8 },
      {
        id: 'kaava', label: 'Laskentakaava', type: 'select', options: [
          { value: 'brzycki', label: 'Brzycki' },
          { value: 'epley', label: 'Epley' },
          { value: 'lander', label: 'Lander' }
        ]
      }
    ],
    compute: function (v) {
      var rm;
      if (v.kaava === 'epley') rm = v.paino * (1 + 0.0333 * v.toistot);
      else if (v.kaava === 'lander') rm = (100 * v.paino) / (101.3 - 2.67123 * v.toistot);
      else rm = v.paino * (36 / (37 - v.toistot));

      var prosentit = [[100, '1'], [95, '2–3'], [90, '4'], [85, '6'], [80, '8'],
        [75, '10'], [70, '12'], [65, '15'], [60, '20+']];
      var rows = prosentit.map(function (p) {
        return [p[0] + ' % (' + p[1] + ' toistoa)', fi(rm * p[0] / 100, 1) + ' kg'];
      });

      var note = 'Arvio perustuu toistomaksimikaavaan. Kaavat ovat tarkimmillaan 1–10 toistolla.';
      if (v.toistot > 10) {
        note = 'Yli 10 toiston sarjoissa arvio on selvästi epätarkempi. ' + note;
      }

      return {
        value: fi(rm, 1),
        unit: 'kg',
        label: v.liike + ' – arvioitu 1RM',
        tone: 'good',
        rows: rows,
        note: note
      };
    }
  };

  // ---------------------------------------------------------------- vesimäärä

  LASKURIT.vesimaara = {
    title: 'Vedentarvelaskuri',
    fields: [
      { id: 'paino', label: 'Paino (kg)', type: 'range', min: 40, max: 200, step: 0.5, value: 70 },
      {
        id: 'aktiivisuus', label: 'Aktiivisuustaso', type: 'select', options: [
          { value: '30', label: 'Vähäinen aktiivisuus' },
          { value: '35', label: 'Kevyt aktiivisuus' },
          { value: '40', label: 'Kohtalainen aktiivisuus' },
          { value: '45', label: 'Korkea aktiivisuus' },
          { value: '50', label: 'Urheilija' }
        ], value: '35'
      },
      { id: 'kuuma', label: 'Kuuma ilmasto tai runsas hikoilu', type: 'checkbox' },
      { id: 'kofeiini', label: 'Runsas kofeiinin käyttö', type: 'checkbox' },
      { id: 'treeni', label: 'Treenipäivä', type: 'checkbox' }
    ],
    compute: function (v) {
      var perus = v.paino * parseFloat(v.aktiivisuus);
      var lisa = (v.kuuma ? 500 : 0) + (v.kofeiini ? 300 : 0) + (v.treeni ? 750 : 0);
      var yht = perus + lisa;
      return {
        value: fi(yht / 1000, 1),
        unit: 'litraa/vrk',
        label: 'Arvioitu nesteen kokonaistarve',
        tone: 'good',
        rows: [
          ['Perustarve', fi(perus / 1000, 1) + ' l'],
          ['Lisätarve', fi(lisa / 1000, 1) + ' l'],
          ['Vastaa lasillisina (2 dl)', Math.ceil(yht / 200) + ' kpl'],
          ['Kerroin', v.aktiivisuus + ' ml painokiloa kohden']
        ],
        note: 'Kokonaistarve sisältää myös ruoasta saatavan nesteen, josta tulee tyypillisesti 20–30 %.'
      };
    }
  };

  // ---------------------------------------------------------------- unisykli

  LASKURIT.unisykli = {
    title: 'Unisyklilaskuri',
    fields: [
      {
        id: 'suunta', label: 'Mitä lasketaan', type: 'select', options: [
          { value: 'nukkumaan', label: 'Milloin mennä nukkumaan (tiedän heräämisajan)' },
          { value: 'heraan', label: 'Milloin herätä (tiedän nukkumaanmenoajan)' }
        ]
      },
      { id: 'aika', label: 'Kellonaika', type: 'time', value: '07:00' }
    ],
    compute: function (v) {
      var osat = String(v.aika || '07:00').split(':');
      var h = parseInt(osat[0], 10) || 0;
      var m = parseInt(osat[1], 10) || 0;
      var nukahtaminen = 15; // min
      var sykli = 90; // min

      function fmt(min) {
        min = ((min % 1440) + 1440) % 1440;
        return String(Math.floor(min / 60)).padStart(2, '0') + ':' + String(min % 60).padStart(2, '0');
      }

      var pohja = h * 60 + m;
      var chips = [];
      var rows = [];
      for (var i = 6; i >= 3; i--) {
        var kesto = i * sykli;
        var aika = v.suunta === 'nukkumaan'
          ? pohja - kesto - nukahtaminen
          : pohja + kesto + nukahtaminen;
        chips.push({ text: fmt(aika), best: i === 5 || i === 6 });
        rows.push([i + ' unisykliä (' + fi(kesto / 60, 1) + ' h unta)', fmt(aika)]);
      }

      return {
        value: chips.length ? chips[0].text : '–',
        label: v.suunta === 'nukkumaan'
          ? 'Suositeltu nukkumaanmenoaika (6 sykliä)'
          : 'Suositeltu heräämisaika (6 sykliä)',
        tone: 'good',
        chips: chips,
        rows: rows,
        note: 'Laskenta olettaa 90 minuutin unisyklin ja noin 15 minuutin nukahtamisajan. Herääminen syklin lopussa tuntuu yleensä virkeämmältä kuin kesken syvää unta.'
      };
    }
  };

  // ---------------------------------------------------------------- VO2max

  LASKURIT['vo2-max'] = {
    title: 'VO2max-laskuri',
    fields: [
      { id: 'ika', label: 'Ikä (vuotta)', type: 'range', min: 18, max: 90, step: 1, value: 30 },
      { id: 'sukupuoli', label: 'Sukupuoli', type: 'select', options: SEX },
      { id: 'leposyke', label: 'Leposyke (bpm)', type: 'range', min: 35, max: 100, step: 1, value: 60 }
    ],
    compute: function (v) {
      var max = Math.round(208 - 0.7 * v.ika); // Tanaka
      var vo2 = 15.3 * (max / v.leposyke);

      var rajat = v.sukupuoli === 'nainen'
        ? [[24, 'Heikko'], [31, 'Välttävä'], [34, 'Kohtalainen'], [38, 'Keskitaso'], [43, 'Hyvä'], [51, 'Erinomainen']]
        : [[33, 'Heikko'], [37, 'Välttävä'], [42, 'Kohtalainen'], [47, 'Keskitaso'], [52, 'Hyvä'], [60, 'Erinomainen']];
      var label = 'Huippukunto', tone = 'good';
      for (var i = 0; i < rajat.length; i++) {
        if (vo2 < rajat[i][0]) {
          label = rajat[i][1];
          tone = i <= 1 ? 'warn' : 'good';
          break;
        }
      }

      return {
        value: fi(vo2, 1),
        unit: 'ml/kg/min',
        label: label,
        tone: tone,
        rows: [
          ['Arvioitu maksimisyke (Tanaka)', max + ' bpm'],
          ['Leposyke', v.leposyke + ' bpm'],
          ['Menetelmä', 'Uth–Sørensen–Overgaard–Pedersen']
        ],
        note: 'Sykkeisiin perustuva arvio. Mittaa leposyke heti heräämisen jälkeen maaten. Tarkka VO2max saadaan laboratoriotestillä.'
      };
    }
  };

  // ---------------------------------------------------------------- treenin palautuminen

  LASKURIT['treenin-palautuminen'] = {
    title: 'Palautumislaskuri',
    fields: [
      {
        id: 'intensiteetti', label: 'Treenin intensiteetti', type: 'select', options: [
          { value: '24', label: 'Kevyt (40–60 % maksimista)' },
          { value: '36', label: 'Kohtalainen (60–75 % maksimista)' },
          { value: '48', label: 'Raskas (75–90 % maksimista)' },
          { value: '72', label: 'Erittäin raskas (90–100 % maksimista)' }
        ], value: '36'
      },
      {
        id: 'lihasryhma', label: 'Lihasryhmä', type: 'select', options: [
          { value: '1.2', label: 'Jalat' },
          { value: '1.1', label: 'Selkä' },
          { value: '1.0', label: 'Rinta' },
          { value: '0.9', label: 'Olkapäät' },
          { value: '0.8', label: 'Käsivarret' },
          { value: '0.8', label: 'Keskivartalo' },
          { value: '1.3', label: 'Koko keho' },
          { value: '0.7', label: 'Kardio / kestävyys' }
        ], value: '1.0'
      },
      { id: 'ika', label: 'Ikä (vuotta)', type: 'range', min: 18, max: 90, step: 1, value: 30 },
      {
        id: 'taso', label: 'Kuntotaso', type: 'select', options: [
          { value: '1.2', label: 'Aloittelija' },
          { value: '1.0', label: 'Keskitaso' },
          { value: '0.9', label: 'Edistynyt' },
          { value: '0.85', label: 'Huipputaso' }
        ], value: '1.0'
      }
    ],
    compute: function (v) {
      var perus = parseFloat(v.intensiteetti);
      var ikakerroin = v.ika > 40 ? 1 + (v.ika - 40) * 0.01 : 1;
      var tunnit = perus * parseFloat(v.lihasryhma) * ikakerroin * parseFloat(v.taso);
      var vrk = tunnit / 24;

      return {
        value: fi(tunnit, 0),
        unit: 'tuntia',
        label: 'Arvioitu palautumisaika',
        tone: 'good',
        rows: [
          ['Vuorokausina', fi(vrk, 1) + ' vrk'],
          ['Seuraava vastaava treeni aikaisintaan', fi(vrk, 1) + ' vrk kuluttua'],
          ['Ikäkerroin', fi(ikakerroin, 2)],
          ['Kevyt liikunta palautumisen aikana', 'Suositeltavaa']
        ],
        note: 'Arvio koskee saman lihasryhmän kuormittamista uudelleen. Uni, ravinto ja stressi vaikuttavat palautumiseen enemmän kuin mikään laskukaava.'
      };
    }
  };

  // ---------------------------------------------------------------- lihasmassa (FFMI)

  LASKURIT.lihasmassa = {
    title: 'Lihasmassalaskuri (FFMI)',
    fields: [
      { id: 'sukupuoli', label: 'Sukupuoli', type: 'select', options: SEX },
      { id: 'paino', label: 'Paino (kg)', type: 'range', min: 40, max: 200, step: 0.5, value: 80 },
      { id: 'pituus', label: 'Pituus (cm)', type: 'range', min: 140, max: 220, step: 1, value: 180 },
      { id: 'rasva', label: 'Rasvaprosentti (%)', type: 'range', min: 3, max: 60, step: 0.5, value: 15 }
    ],
    compute: function (v) {
      var m = v.pituus / 100;
      var rasvaton = v.paino * (1 - v.rasva / 100);
      var ffmi = rasvaton / (m * m);
      // Normalisointi 180 cm:n pituuteen (Kouri ym.)
      var norm = ffmi + 6.1 * (1.8 - m);

      var rajat = v.sukupuoli === 'nainen'
        ? [[14, 'Alhainen lihasmassa'], [16, 'Keskimääräistä alhaisempi'], [18, 'Keskimääräinen'], [20, 'Keskimääräistä korkeampi'], [22, 'Erinomainen']]
        : [[17, 'Alhainen lihasmassa'], [19, 'Keskimääräistä alhaisempi'], [21, 'Keskimääräinen'], [23, 'Keskimääräistä korkeampi'], [25, 'Erinomainen']];
      var label = 'Poikkeuksellisen korkea', tone = 'good';
      for (var i = 0; i < rajat.length; i++) {
        if (norm < rajat[i][0]) { label = rajat[i][1]; tone = i === 0 ? 'warn' : 'good'; break; }
      }

      return {
        value: fi(norm, 1),
        label: label,
        tone: tone,
        rows: [
          ['Rasvaton kehonpaino', fi(rasvaton, 1) + ' kg'],
          ['Rasvamassa', fi(v.paino - rasvaton, 1) + ' kg'],
          ['FFMI (normalisoimaton)', fi(ffmi, 1)],
          ['Normalisointi', '180 cm:n pituuteen']
        ],
        note: 'FFMI kertoo rasvattoman massan suhteessa pituuteen. Tulos on täsmälleen niin tarkka kuin syötetty rasvaprosentti.'
      };
    }
  };

  // ---------------------------------------------------------------- proteiinintarve

  LASKURIT.proteiinintarve = {
    title: 'Proteiinintarvelaskuri',
    fields: [
      { id: 'paino', label: 'Paino (kg)', type: 'range', min: 40, max: 200, step: 0.5, value: 70 },
      { id: 'ika', label: 'Ikä (vuotta)', type: 'range', min: 15, max: 100, step: 1, value: 30 },
      {
        id: 'aktiivisuus', label: 'Aktiivisuustaso', type: 'select', options: [
          { value: '0.8', label: 'Vähän liikkuva' },
          { value: '1.0', label: 'Kevyesti aktiivinen' },
          { value: '1.2', label: 'Kohtuullisesti aktiivinen' },
          { value: '1.4', label: 'Erittäin aktiivinen' },
          { value: '1.6', label: 'Urheilija' },
          { value: '1.8', label: 'Voimaharjoittelu' }
        ], value: '1.2'
      },
      {
        id: 'tavoite', label: 'Tavoite', type: 'select', options: [
          { value: '1.0', label: 'Ylläpito' },
          { value: '1.2', label: 'Rasvanpudotus' },
          { value: '1.3', label: 'Lihasmassan kasvu' },
          { value: '1.4', label: 'Palautuminen' }
        ], value: '1.0'
      }
    ],
    compute: function (v) {
      var perus = v.paino * parseFloat(v.aktiivisuus) * parseFloat(v.tavoite);
      // Yli 65-vuotiailla suositus on korkeampi lihaskadon ehkäisemiseksi
      var ikalisa = v.ika >= 65 ? 1.15 : 1;
      var yht = perus * ikalisa;
      var yla = Math.min(yht * 1.15, v.paino * 2.2);

      return {
        value: fi(yht, 0) + '–' + fi(yla, 0),
        unit: 'g/vrk',
        label: 'Päivittäinen proteiinintarve',
        tone: 'good',
        rows: [
          ['Painokiloa kohden', fi(yht / v.paino, 2) + ' g/kg'],
          ['Energiana', fi(yht * 4, 0) + ' kcal'],
          ['Jaettuna 4 ateriaan', fi(yht / 4, 0) + ' g/ateria'],
          ['Ikäkorjaus', v.ika >= 65 ? 'Kyllä (+15 %, yli 65 v)' : 'Ei']
        ],
        note: 'Proteiini kannattaa jakaa tasaisesti päivän aterioille. Yli 2,2 g/kg ei tutkimusten mukaan tuo lisähyötyä.'
      };
    }
  };

  // ---------------------------------------------------------------- sykealueet

  LASKURIT.sykealueet = {
    title: 'Sykealuelaskuri',
    fields: [
      { id: 'ika', label: 'Ikä (vuotta)', type: 'range', min: 15, max: 100, step: 1, value: 30 },
      { id: 'leposyke', label: 'Leposyke (bpm)', type: 'range', min: 35, max: 100, step: 1, value: 60 },
      {
        id: 'lahde', label: 'Maksimisyke', type: 'select', options: [
          { value: 'tanaka', label: 'Arvioi iän perusteella (Tanaka)' },
          { value: 'oma', label: 'Syötän oman mitatun arvon' }
        ]
      },
      { id: 'maksimi', label: 'Mitattu maksimisyke (bpm)', type: 'range', min: 120, max: 220, step: 1, value: 190, showIf: { lahde: 'oma' } },
      {
        id: 'tapa', label: 'Laskentatapa', type: 'select', options: [
          { value: 'karvonen', label: 'Karvonen (sykereservi)' },
          { value: 'prosentti', label: 'Prosenttia maksimisykkeestä' }
        ]
      }
    ],
    compute: function (v) {
      var max = v.lahde === 'oma' ? v.maksimi : Math.round(208 - 0.7 * v.ika);
      var reservi = max - v.leposyke;
      var zs = [
        ['Z1 Palauttava', 0.5, 0.6, 'Aktiivinen palautuminen'],
        ['Z2 Peruskestävyys', 0.6, 0.7, 'Pitkäkestoinen aerobinen'],
        ['Z3 Vauhtikestävyys', 0.7, 0.8, 'Aerobinen kynnys, tempotreeni'],
        ['Z4 Maksimikestävyys', 0.8, 0.9, 'Anaerobinen kynnys, intervallit'],
        ['Z5 Maksimaalinen', 0.9, 1.0, 'Maksimaalinen, 3–5 min kerrallaan']
      ];
      var rows = zs.map(function (z) {
        var lo = v.tapa === 'karvonen' ? v.leposyke + reservi * z[1] : max * z[1];
        var hi = v.tapa === 'karvonen' ? v.leposyke + reservi * z[2] : max * z[2];
        return [z[0] + ' – ' + z[3], Math.round(lo) + '–' + Math.round(hi) + ' bpm'];
      });
      return {
        value: String(max),
        unit: 'bpm',
        label: v.lahde === 'oma' ? 'Mitattu maksimisyke' : 'Arvioitu maksimisyke (Tanaka)',
        tone: 'good',
        rows: [['Leposyke', v.leposyke + ' bpm'], ['Sykereservi', reservi + ' bpm']].concat(rows),
        note: v.tapa === 'karvonen'
          ? 'Karvosen menetelmä huomioi leposykkeen ja antaa yksilöllisemmät alueet kuin pelkkä prosenttiosuus maksimisykkeestä.'
          : 'Prosenttiosuus maksimisykkeestä on yksinkertaisin tapa, mutta ei huomioi kuntotasoa. Karvosen menetelmä on tarkempi.'
      };
    }
  };

  // ---------------------------------------------------------------- raskausajan painonseuranta

  LASKURIT.raskauspaino = {
    title: 'Raskausajan painonseurantalaskuri',
    fields: [
      { id: 'alkupaino', label: 'Paino ennen raskautta (kg)', type: 'range', min: 40, max: 150, step: 0.5, value: 65 },
      { id: 'pituus', label: 'Pituus (cm)', type: 'range', min: 140, max: 200, step: 1, value: 165 },
      { id: 'nykypaino', label: 'Nykyinen paino (kg)', type: 'range', min: 40, max: 180, step: 0.5, value: 68 },
      { id: 'viikko', label: 'Raskausviikko', type: 'range', min: 1, max: 42, step: 1, value: 20 },
      { id: 'kaksoset', label: 'Kaksosraskaus', type: 'checkbox' }
    ],
    compute: function (v) {
      var m = v.pituus / 100;
      var bmi = v.alkupaino / (m * m);
      var nousu = v.nykypaino - v.alkupaino;

      // Suositukset: Institute of Medicine (IOM) 2009 -ohjeistus,
      // luokka maaraytyy raskautta edeltavan BMI:n mukaan.
      var luokka, min, max, viikkoMin, viikkoMax;
      if (v.kaksoset) {
        luokka = 'Kaksosraskaus'; min = 16.8; max = 24.5; viikkoMin = 0.6; viikkoMax = 0.8;
      } else if (bmi < 18.5) {
        luokka = 'Alipaino (BMI alle 18,5)'; min = 12.5; max = 18; viikkoMin = 0.44; viikkoMax = 0.58;
      } else if (bmi < 25) {
        luokka = 'Normaalipaino (BMI 18,5–24,9)'; min = 11.5; max = 16; viikkoMin = 0.35; viikkoMax = 0.5;
      } else if (bmi < 30) {
        luokka = 'Ylipaino (BMI 25–29,9)'; min = 7; max = 11.5; viikkoMin = 0.23; viikkoMax = 0.33;
      } else {
        luokka = 'Lihavuus (BMI vähintään 30)'; min = 5; max = 9; viikkoMin = 0.17; viikkoMax = 0.27;
      }

      // Ensimmaisen kolmanneksen nousu on pieni (n. 0,5-2 kg), sen jalkeen tasaisempi.
      var alkuNousu = v.kaksoset ? 1.5 : (bmi < 25 ? 1.5 : 0.5);
      var odotettuMin, odotettuMax;
      if (v.viikko <= 13) {
        odotettuMin = 0;
        odotettuMax = alkuNousu;
      } else {
        var viikkoja = v.viikko - 13;
        odotettuMin = alkuNousu * 0.5 + viikkoMin * viikkoja;
        odotettuMax = alkuNousu + viikkoMax * viikkoja;
      }

      var label, tone;
      if (nousu < odotettuMin) { label = 'Painonnousu on suositusta hitaampaa'; tone = 'warn'; }
      else if (nousu > odotettuMax) { label = 'Painonnousu on suositusta nopeampaa'; tone = 'warn'; }
      else { label = 'Painonnousu on suositusten mukainen'; tone = 'good'; }

      return {
        value: (nousu >= 0 ? '+' : '') + fi(nousu, 1),
        unit: 'kg',
        label: label,
        tone: tone,
        rows: [
          ['Raskautta edeltävä BMI', fi(bmi, 1) + ' – ' + luokka],
          ['Suositus viikolla ' + v.viikko, fi(odotettuMin, 1) + '–' + fi(odotettuMax, 1) + ' kg'],
          ['Koko raskauden suositus', fi(min, 1) + '–' + fi(max, 1) + ' kg'],
          ['Suositeltu vauhti (2. ja 3. kolmannes)', fi(viikkoMin, 2) + '–' + fi(viikkoMax, 2) + ' kg/vko']
        ],
        note: 'Suositukset perustuvat Institute of Medicinen (2009) ohjeistukseen. Yksilöllinen tilanne arvioidaan aina neuvolassa – tämä laskuri ei korvaa terveydenhuollon seurantaa.'
      };
    }
  };

  // ---------------------------------------------------------------- kuntoutusaika

  var VAMMAT = {
    lihas: {
      label: 'Lihasvamma', asteet: [
        { value: '2', label: '1. asteen revähdys (lievä venähdys)' },
        { value: '4', label: '2. asteen revähdys (osittainen repeämä)' },
        { value: '8', label: '3. asteen revähdys (täydellinen repeämä)' }
      ]
    },
    nivelside: {
      label: 'Nivelsidevamma', asteet: [
        { value: '2', label: '1. asteen nyrjähdys (venyttyminen)' },
        { value: '6', label: '2. asteen nyrjähdys (osittainen repeämä)' },
        { value: '12', label: '3. asteen nyrjähdys (täydellinen repeämä)' }
      ]
    },
    murtuma: {
      label: 'Murtuma', asteet: [
        { value: '6', label: 'Yksinkertainen murtuma' },
        { value: '8', label: 'Rasitusmurtuma' },
        { value: '12', label: 'Komplisoitunut murtuma' }
      ]
    },
    leikkaus: {
      label: 'Leikkaus', asteet: [
        { value: '8', label: 'Tähystysleikkaus' },
        { value: '16', label: 'Avoleikkaus' },
        { value: '24', label: 'Nivelsiteen korjausleikkaus' }
      ]
    }
  };

  LASKURIT.kuntoutusaika = {
    title: 'Kuntoutusaikalaskuri',
    fields: [
      {
        id: 'tyyppi', label: 'Vammatyyppi', type: 'select',
        options: Object.keys(VAMMAT).map(function (k) { return { value: k, label: VAMMAT[k].label }; })
      },
      { id: 'aste', label: 'Vamman vakavuus', type: 'select', options: [], dependsOn: 'tyyppi' },
      {
        id: 'ika', label: 'Ikäryhmä', type: 'select', options: [
          { value: '0.9', label: 'Alle 30 v' },
          { value: '1.0', label: '30–50 v' },
          { value: '1.2', label: 'Yli 50 v' }
        ], value: '1.0'
      },
      {
        id: 'terveys', label: 'Yleinen terveydentila', type: 'select', options: [
          { value: '0.9', label: 'Erinomainen' },
          { value: '1.0', label: 'Hyvä' },
          { value: '1.1', label: 'Kohtalainen' },
          { value: '1.2', label: 'Heikko' }
        ], value: '1.0'
      },
      {
        id: 'sitoutuminen', label: 'Sitoutuminen kuntoutukseen', type: 'select', options: [
          { value: '0.9', label: 'Erinomainen – teen ohjeet säännöllisesti' },
          { value: '1.0', label: 'Normaali' },
          { value: '1.2', label: 'Heikko – harjoittelu jää usein väliin' }
        ], value: '1.0'
      }
    ],
    optionsFor: function (fieldId, v) {
      if (fieldId === 'aste') return (VAMMAT[v.tyyppi] || VAMMAT.lihas).asteet;
      return null;
    },
    compute: function (v) {
      var perus = parseFloat(v.aste);
      var kerroin = parseFloat(v.ika) * parseFloat(v.terveys) * parseFloat(v.sitoutuminen);
      var viikot = perus * kerroin;
      var alaraja = viikot * 0.8;
      var ylaraja = viikot * 1.25;

      return {
        value: fi(alaraja, 0) + '–' + fi(ylaraja, 0),
        unit: 'viikkoa',
        label: 'Arvioitu kuntoutusaika',
        tone: 'good',
        rows: [
          ['Vamman perusaika', fi(perus, 0) + ' viikkoa'],
          ['Yksilöllinen kerroin', fi(kerroin, 2)],
          ['Keskiarvio', fi(viikot, 0) + ' viikkoa'],
          ['Paluu urheiluun', 'Vasta kivuttoman täyden liikeradan ja voiman palattua']
        ],
        note: 'Karkea arvio kirjallisuuden keskiarvoista. Vamman todellinen laatu, kuvantamislöydökset ja hoitava ammattilainen ratkaisevat aikataulun – hakeudu aina arvioon.'
      };
    }
  };

  // ---------------------------------------------------------------- treeniohjelma

  LASKURIT.treeniohjelma = {
    title: 'Treeniohjelmalaskuri',
    fields: [
      {
        id: 'tavoite', label: 'Harjoittelun tavoite', type: 'select', options: [
          { value: 'voima', label: 'Voimaharjoittelu' },
          { value: 'kesto', label: 'Kestävyysharjoittelu' },
          { value: 'pudotus', label: 'Painonpudotus' },
          { value: 'massa', label: 'Lihasmassan kasvatus' },
          { value: 'yleis', label: 'Yleiskunto' }
        ]
      },
      {
        id: 'kokemus', label: 'Kokemus', type: 'select', options: [
          { value: 'aloittelija', label: 'Aloittelija (alle 1 v)' },
          { value: 'keskitaso', label: 'Keskitaso (1–3 v)' },
          { value: 'edistynyt', label: 'Edistynyt (yli 3 v)' }
        ]
      },
      { id: 'kerrat', label: 'Treenejä viikossa', type: 'range', min: 2, max: 6, step: 1, value: 3 },
      { id: 'kesto', label: 'Ohjelman kesto (viikkoa)', type: 'range', min: 4, max: 24, step: 1, value: 12 }
    ],
    compute: function (v) {
      var mallit = {
        voima: { sarjat: '3–5', toistot: '3–6', kuorma: '80–90 % 1RM', tauko: '3–5 min' },
        kesto: { sarjat: '–', toistot: '20–60 min yhtäjaksoista', kuorma: 'Syke Z2–Z3', tauko: '–' },
        pudotus: { sarjat: '3–4', toistot: '10–15', kuorma: '60–70 % 1RM', tauko: '45–60 s' },
        massa: { sarjat: '3–4', toistot: '8–12', kuorma: '70–80 % 1RM', tauko: '60–90 s' },
        yleis: { sarjat: '2–3', toistot: '10–15', kuorma: '60–70 % 1RM', tauko: '60 s' }
      };
      var jaot = {
        2: 'Kokovartalo × 2',
        3: 'Kokovartalo × 3 tai ylä/ala/kokovartalo',
        4: 'Ylä/ala × 2',
        5: 'Työntö/veto/jalat + 2 kokovartalo',
        6: 'Työntö/veto/jalat × 2'
      };
      var malli = mallit[v.tavoite] || mallit.yleis;
      var deload = Math.floor(v.kesto / 6);
      var tehokkaat = v.kesto - deload;
      var yhteensa = v.kesto * v.kerrat;

      var kokemusVinkki = {
        aloittelija: 'Aloittelijana painota tekniikkaa ja nouse kuormassa maltillisesti. Kokovartaloharjoittelu tuottaa parhaan tuloksen.',
        keskitaso: 'Keskitasolla jaksotus alkaa merkitä: vaihda kuormaa ja toistomääriä 4–6 viikon jaksoissa.',
        edistynyt: 'Edistyneenä kehitys vaatii tarkempaa jaksotusta ja riittävää palautumista – deload-viikot eivät ole valinnaisia.'
      }[v.kokemus];

      return {
        value: String(yhteensa),
        unit: 'harjoitusta',
        label: v.kesto + ' viikon ohjelma, ' + v.kerrat + ' krt/vko',
        tone: 'good',
        rows: [
          ['Jakomalli', jaot[v.kerrat] || 'Kokovartalo'],
          ['Sarjat', malli.sarjat],
          ['Toistot', malli.toistot],
          ['Kuorma', malli.kuorma],
          ['Palautus sarjojen välillä', malli.tauko],
          ['Kevennysviikkoja (deload)', deload + ' kpl'],
          ['Tehokkaita harjoitusviikkoja', tehokkaat + ' vko']
        ],
        note: kokemusVinkki
      };
    }
  };

  // ---------------------------------------------------------------- energiantuotanto

  LASKURIT.energiantuotanto = {
    title: 'Energiantuotannon analyysilaskuri',
    fields: [
      {
        id: 'laji', label: 'Aktiviteetti', type: 'select', options: [
          { value: '3.5', label: 'Kävely' },
          { value: '7', label: 'Hölkkä' },
          { value: '9.8', label: 'Juoksu' },
          { value: '14', label: 'Sprinttiharjoittelu' },
          { value: '6', label: 'Pyöräily' },
          { value: '7', label: 'Uinti' },
          { value: '5', label: 'Voimaharjoittelu' },
          { value: '9', label: 'HIIT' }
        ], value: '7'
      },
      { id: 'teho', label: 'Intensiteetti (% maksimisykkeestä)', type: 'range', min: 50, max: 100, step: 1, value: 75 },
      { id: 'kesto', label: 'Kesto (minuuttia)', type: 'range', min: 5, max: 180, step: 5, value: 30 },
      { id: 'paino', label: 'Paino (kg)', type: 'range', min: 40, max: 150, step: 0.5, value: 70 }
    ],
    compute: function (v) {
      var kcal = (parseFloat(v.laji) * 3.5 * v.paino / 200) * v.kesto;

      // Aerobisen ja anaerobisen energiantuoton osuudet sykealueittain.
      var vyohyke, aerobinen, rasva;
      if (v.teho < 60) { vyohyke = 'Z1 Palauttava'; aerobinen = 95; rasva = 60; }
      else if (v.teho < 70) { vyohyke = 'Z2 Peruskestävyys'; aerobinen = 90; rasva = 50; }
      else if (v.teho < 80) { vyohyke = 'Z3 Vauhtikestävyys'; aerobinen = 80; rasva = 35; }
      else if (v.teho < 90) { vyohyke = 'Z4 Maksimikestävyys'; aerobinen = 65; rasva = 20; }
      else { vyohyke = 'Z5 Maksimaalinen'; aerobinen = 40; rasva = 10; }

      var hiilari = 100 - rasva;
      return {
        value: fi(kcal, 0),
        unit: 'kcal',
        label: vyohyke + ', ' + v.kesto + ' min',
        tone: 'good',
        rows: [
          ['Aerobinen energiantuotto', aerobinen + ' %'],
          ['Anaerobinen energiantuotto', (100 - aerobinen) + ' %'],
          ['Energiasta rasvasta', rasva + ' % (' + fi(kcal * rasva / 100, 0) + ' kcal)'],
          ['Energiasta hiilihydraatista', hiilari + ' % (' + fi(kcal * hiilari / 100, 0) + ' kcal)'],
          ['Rasvaa poltettu', fi(kcal * rasva / 100 / 7.7, 0) + ' g'],
          ['Hiilihydraattia kulunut', fi(kcal * hiilari / 100 / 4, 0) + ' g']
        ],
        note: 'Osuudet ovat sykealuekohtaisia keskiarvoja. Harjoitusvaikutus ei määräydy vain poltetun rasvan mukaan – kokonaiskulutus ratkaisee painonhallinnassa enemmän.'
      };
    }
  };

  // ---------------------------------------------------------------- lasten painoindeksi

  /*
   * ISO-BMI eli lapsen painoindeksin aikuisvastine EI ole laskettavissa
   * aikuisten kaavasta ikakertoimella. Se maaritellaan ika- ja
   * sukupuolikohtaisilla raja-arvoilla (IOTF / Cole ym. tai suomalainen
   * kasvureferenssi), joissa lapsen BMI kuvataan sille aikuisian BMI-arvolle,
   * jota se vastaa.
   *
   * Aiempi toteutus kaytti kaavaa bmi * (1 + (18 - ika) * 0.01), joka ei
   * perustu mihinkaan viitearvoon. Sita EI ole portattu tanne.
   *
   * Taulukko taytetaan muodossa:
   *   VIITEARVOT.poika[ika] = [bmi16, bmi17, bmi18_5, bmi25, bmi30]
   * eli lapsen BMI-raja, joka vastaa aikuisen BMI-arvoja 16 / 17 / 18,5 / 25 / 30.
   * Kun taulukko on paikallaan, ISO-BMI interpoloidaan naiden pisteiden valilla.
   */
  var ISOBMI_VIITEARVOT = null; // odottaa varmennettuja arvoja

  function isoBmiAikuisvastine(bmi, ika, sukupuoli) {
    if (!ISOBMI_VIITEARVOT) return null;
    var taulu = ISOBMI_VIITEARVOT[sukupuoli === 'tytto' ? 'tytto' : 'poika'];
    if (!taulu) return null;
    var alaIka = Math.floor(ika * 2) / 2;
    var rajat = taulu[alaIka.toFixed(1)] || taulu[String(alaIka)];
    if (!rajat) return null;
    var aikuis = [16, 17, 18.5, 25, 30];
    if (bmi <= rajat[0]) return aikuis[0] * (bmi / rajat[0]);
    for (var i = 0; i < rajat.length - 1; i++) {
      if (bmi <= rajat[i + 1]) {
        var osuus = (bmi - rajat[i]) / (rajat[i + 1] - rajat[i]);
        return aikuis[i] + osuus * (aikuis[i + 1] - aikuis[i]);
      }
    }
    return aikuis[aikuis.length - 1] * (bmi / rajat[rajat.length - 1]);
  }

  LASKURIT['lasten-painoindeksi'] = {
    title: 'Lasten painoindeksilaskuri',
    fields: [
      {
        id: 'sukupuoli', label: 'Sukupuoli', type: 'select', options: [
          { value: 'poika', label: 'Poika' },
          { value: 'tytto', label: 'Tyttö' }
        ]
      },
      { id: 'ika', label: 'Ikä (vuotta)', type: 'range', min: 2, max: 18, step: 0.5, value: 10 },
      { id: 'paino', label: 'Paino (kg)', type: 'range', min: 10, max: 120, step: 0.5, value: 35 },
      { id: 'pituus', label: 'Pituus (cm)', type: 'range', min: 50, max: 200, step: 1, value: 140 }
    ],
    compute: function (v) {
      var m = v.pituus / 100;
      var bmi = v.paino / (m * m);
      var iso = isoBmiAikuisvastine(bmi, v.ika, v.sukupuoli);

      if (iso === null) {
        return {
          value: fi(bmi, 1),
          label: 'Lapsen painoindeksi',
          tone: 'good',
          rows: [
            ['Ikä', fi(v.ika, 1) + ' v'],
            ['Paino', fi(v.paino, 1) + ' kg'],
            ['Pituus', v.pituus + ' cm'],
            ['Aikuisvastine (ISO-BMI)', 'Ei laskettavissa ilman viitearvoja']
          ],
          note: 'Lapsen painoindeksiä ei tulkita aikuisten raja-arvoilla, koska kehon koostumus muuttuu kasvun aikana. ' +
            'Luku kertoo painon suhteen pituuteen, mutta luokitus (ali-, normaali- tai ylipaino) vaatii ikä- ja ' +
            'sukupuolikohtaiset kasvukäyrät. Neuvola ja kouluterveydenhuolto seuraavat näitä käyriä – kysy tulkinta sieltä.'
        };
      }

      var label, tone;
      if (iso < 17) { label = 'Alipaino'; tone = 'warn'; }
      else if (iso < 25) { label = 'Normaali paino'; tone = 'good'; }
      else if (iso < 30) { label = 'Ylipaino'; tone = 'warn'; }
      else { label = 'Lihavuus'; tone = 'bad'; }

      return {
        value: fi(iso, 1),
        label: label + ' (ISO-BMI)',
        tone: tone,
        rows: [
          ['Lapsen oma BMI', fi(bmi, 1)],
          ['Ikä', fi(v.ika, 1) + ' v'],
          ['Aikuisvastine', fi(iso, 1)]
        ],
        note: 'ISO-BMI kertoo, mitä aikuisen painoindeksiä lapsen paino vastaa. Tulos on suuntaa-antava eikä korvaa ' +
          'neuvolan tai kouluterveydenhuollon kasvunseurantaa.'
      };
    }
  };

  // ---------------------------------------------------------------- moottori

  function el(tag, cls, text) {
    var e = document.createElement(tag);
    if (cls) e.className = cls;
    if (text !== undefined) e.textContent = text;
    return e;
  }

  function buildField(def, state, onChange, calc) {
    var wrap = el('div', 'fk-field');
    wrap.setAttribute('data-field', def.id);

    if (def.type === 'checkbox') {
      var lbl = el('label', 'fk-check');
      var cb = el('input');
      cb.type = 'checkbox';
      cb.checked = !!state[def.id];
      cb.addEventListener('change', function () { onChange(def.id, cb.checked); });
      lbl.appendChild(cb);
      lbl.appendChild(el('span', null, def.label));
      wrap.appendChild(lbl);
      return wrap;
    }

    var id = 'fk-' + def.id + '-' + Math.random().toString(36).slice(2, 7);
    var label = el('label', 'fk-field__label', def.label);
    label.setAttribute('for', id);
    wrap.appendChild(label);

    var row = el('div', 'fk-field__row');

    if (def.type === 'select') {
      var sel = el('select');
      sel.id = id;
      var opts = def.options;
      if (calc && calc.optionsFor) {
        var dyn = calc.optionsFor(def.id, state);
        if (dyn) opts = dyn;
      }
      opts.forEach(function (o) {
        var opt = el('option', null, o.label);
        opt.value = o.value;
        if (String(state[def.id]) === String(o.value)) opt.selected = true;
        sel.appendChild(opt);
      });
      sel.addEventListener('change', function () { onChange(def.id, sel.value); });
      row.appendChild(sel);
    } else if (def.type === 'time') {
      var t = el('input');
      t.type = 'time';
      t.id = id;
      t.value = state[def.id];
      t.addEventListener('input', function () { onChange(def.id, t.value); });
      row.appendChild(t);
    } else {
      var num = el('input');
      num.type = 'number';
      num.id = id;
      if (def.min !== undefined) num.min = def.min;
      if (def.max !== undefined) num.max = def.max;
      if (def.step !== undefined) num.step = def.step;
      num.value = state[def.id];

      if (def.type === 'range') {
        var rng = el('input');
        rng.type = 'range';
        rng.min = def.min;
        rng.max = def.max;
        rng.step = def.step || 1;
        rng.value = state[def.id];
        rng.setAttribute('aria-label', def.label);
        rng.addEventListener('input', function () {
          num.value = rng.value;
          onChange(def.id, parseFloat(rng.value));
        });
        num.addEventListener('input', function () {
          var n = parseFloat(num.value);
          if (isNaN(n)) return;
          rng.value = clamp(n, def.min, def.max);
          onChange(def.id, n);
        });
        row.appendChild(rng);
      } else {
        num.addEventListener('input', function () {
          var n = parseFloat(num.value);
          onChange(def.id, isNaN(n) ? 0 : n);
        });
      }
      row.appendChild(num);
    }

    wrap.appendChild(row);
    if (def.hint) wrap.appendChild(el('p', 'fk-field__hint', def.hint));
    return wrap;
  }

  /*
   * Tulos rakennetaan div-elementeista, ei p/ul/li:sta. Teeman blogityyleissa on
   * syvia selektoreita (esim. .single-blog .post-item .post-info .des li), jotka
   * pakottaisivat display: list-item ja luettelomerkit ja rikkoisivat asettelun.
   */
  function renderResult(target, res) {
    target.innerHTML = '';

    var val = el('div', 'fk-result__value' + (res.tone ? ' fk-result__value--' + res.tone : ''));
    val.appendChild(el('span', 'fk-result__number', String(res.value)));
    if (res.unit) val.appendChild(el('span', 'fk-result__unit', res.unit));
    target.appendChild(val);

    if (res.label) target.appendChild(el('div', 'fk-result__label', res.label));

    if (res.chips && res.chips.length) {
      var chips = el('div', 'fk-chips');
      res.chips.forEach(function (c) {
        chips.appendChild(el('span', 'fk-chip' + (c.best ? ' fk-chip--best' : ''), c.text));
      });
      target.appendChild(chips);
    }

    if (res.rows && res.rows.length) {
      var list = el('div', 'fk-result__rows');
      res.rows.forEach(function (r) {
        var row = el('div', 'fk-row');
        row.appendChild(el('span', 'fk-k', r[0]));
        row.appendChild(el('span', 'fk-v', r[1]));
        list.appendChild(row);
      });
      target.appendChild(list);
    }

    if (res.note) target.appendChild(el('div', 'fk-result__note', res.note));
  }

  function mount(node) {
    var key = node.getAttribute('data-laskuri');
    var calc = LASKURIT[key];
    if (!calc) {
      node.className = 'fk-laskuri fk-laskuri--fallback';
      node.textContent = 'Laskuria ei löytynyt (' + key + ').';
      return;
    }

    node.className = 'fk-laskuri';
    node.innerHTML = '';
    node.appendChild(el('h2', 'fk-laskuri__title', calc.title));

    var grid = el('div', 'fk-laskuri__grid');
    var inputs = el('div', 'fk-laskuri__inputs');
    var result = el('div', 'fk-result');
    grid.appendChild(inputs);
    grid.appendChild(result);
    node.appendChild(grid);

    var state = {};
    calc.fields.forEach(function (f) {
      if (f.type === 'checkbox') state[f.id] = !!f.value;
      else if (f.type === 'select') state[f.id] = f.value !== undefined ? f.value : (f.options[0] || {}).value;
      else state[f.id] = f.value;
    });
    // Riippuvat valikot alustetaan vasta kun muut arvot ovat paikallaan
    calc.fields.forEach(function (f) {
      if (f.type === 'select' && calc.optionsFor) {
        var dyn = calc.optionsFor(f.id, state);
        if (dyn && dyn.length) state[f.id] = dyn[0].value;
      }
    });

    function visible(f) {
      if (!f.showIf) return true;
      return Object.keys(f.showIf).every(function (k) { return state[k] === f.showIf[k]; });
    }

    function draw() {
      inputs.innerHTML = '';
      calc.fields.forEach(function (f) {
        if (!visible(f)) return;
        inputs.appendChild(buildField(f, state, onChange, calc));
      });
      update();
    }

    function update() {
      var res;
      try {
        res = calc.compute(state);
      } catch (e) {
        res = { value: '–', label: 'Laskennassa tapahtui virhe', tone: 'warn', rows: [] };
      }
      renderResult(result, res);
    }

    var rebuildFields = calc.fields.filter(function (f) { return f.showIf; })
      .map(function (f) { return Object.keys(f.showIf); })
      .reduce(function (a, b) { return a.concat(b); }, []);

    function onChange(id, value) {
      state[id] = value;
      var tarvitseeUudelleen = rebuildFields.indexOf(id) !== -1 ||
        calc.fields.some(function (f) { return f.dependsOn === id; });
      if (tarvitseeUudelleen) {
        if (calc.optionsFor) {
          calc.fields.forEach(function (f) {
            if (f.dependsOn === id) {
              var dyn = calc.optionsFor(f.id, state);
              if (dyn && dyn.length) state[f.id] = dyn[0].value;
            }
          });
        }
        draw();
      } else {
        update();
      }
    }

    draw();
  }

  function init() {
    var nodes = document.querySelectorAll('[data-laskuri]:not([data-laskuri-valmis])');
    Array.prototype.forEach.call(nodes, function (n) {
      n.setAttribute('data-laskuri-valmis', '1');
      mount(n);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  window.FysiokauppaLaskurit = { rekisteri: LASKURIT, init: init };
})();
